module.exports = __webpack_public_path__ + "assets/img/wh5_p09.6061f41e.jpg";